import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu } from 'lucide-react';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Handle navigation with scroll
  const handleNavigation = (
    e: React.MouseEvent, 
    path: string, 
    hash: string
  ) => {
    e.preventDefault();
    setMobileMenuOpen(false);

    // If we're already on the target page, just scroll
    if ((path === '/' && location.pathname === '/') || 
        (path === location.pathname)) {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to the new page with hash
      navigate(`${path}${hash ? '#' + hash : ''}`);
    }
  };

  return (
    <nav className="fixed w-full z-50 bg-[#0F0F0F]/80 backdrop-blur-lg border-b border-[#D7FF00]/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img 
                src="/logo.svg" 
                alt="VicoGambles Logo" 
                className="w-auto h-24"
              />
            </Link>
          </div>
          
          <div className="hidden md:flex items-center space-x-4">
            {/* Leaderboard link */}
            <Link 
              to="/leaderboard"
              className="text-gray-300 hover:text-[#D7FF00] px-3 py-2 rounded-md text-sm font-medium"
            >
              Leaderboard
            </Link>
            
            {/* FAQ link - goes to homepage FAQ section */}
            <a 
              href="/#faq"
              onClick={(e) => handleNavigation(e, '/', 'faq')}
              className="text-gray-300 hover:text-[#D7FF00] px-3 py-2 rounded-md text-sm font-medium"
            >
              FAQ
            </a>
            
            {/* Start Playing link - goes to homepage casino-bonuses section */}
            <a 
              href="/#casino-bonuses"
              onClick={(e) => handleNavigation(e, '/', 'casino-bonuses')}
              className="glow-button px-4 py-2 rounded-md text-sm"
            >
              Start Playing
            </a>
          </div>
          
          <div className="md:hidden">
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="flex items-center p-2 rounded-md hover:bg-white/10"
              aria-label="Toggle mobile menu"
            >
              <Menu className="h-6 w-6 text-gray-300" />
            </button>
          </div>
        </div>
        
        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-[#0F0F0F]/95 backdrop-blur-lg border-t border-[#D7FF00]/10 mt-2 p-4 rounded-b-lg animate-fadeIn">
            <div className="flex flex-col space-y-4 px-2 py-3">
              {/* Leaderboard link */}
              <Link 
                to="/leaderboard"
                className="text-gray-300 hover:text-[#D7FF00] px-3 py-2 rounded-md text-sm font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                Leaderboard
              </Link>
              
              {/* FAQ link - goes to homepage FAQ section */}
              <a 
                href="/#faq"
                onClick={(e) => handleNavigation(e, '/', 'faq')}
                className="text-gray-300 hover:text-[#D7FF00] px-3 py-2 rounded-md text-sm font-medium"
              >
                FAQ
              </a>
              
              {/* Start Playing link - goes to homepage casino-bonuses section */}
              <a 
                href="/#casino-bonuses"
                onClick={(e) => handleNavigation(e, '/', 'casino-bonuses')}
                className="glow-button px-4 py-2 rounded-md text-sm w-full text-center"
              >
                Start Playing
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;